import Phaser from "phaser";
import {
  getStageMetaById,
  STAGES,
  type StageId,
} from "@phaser/core/stages/StageCatalog";

export class StageLoader {
  static preloadPreviews(scene: Phaser.Scene) {
    for (const s of STAGES) {
      scene.load.image(s.previewKey, s.previewSrc);
    }
  }

  static preloadBackgrounds(scene: Phaser.Scene) {
    // bgSrc 있는 것만 로드 (002가 bg 없으면 자동으로 스킵)
    for (const s of STAGES) {
      if (s.bgSrc) {
        scene.load.image(s.bgKey, s.bgSrc);
      }
    }
  }

  static preloadSelectedStage(scene: Phaser.Scene, stageId: StageId) {
    const meta = getStageMetaById(stageId);
    scene.load.image(meta.bgKey, meta.bgSrc);
  }
}
